/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-return-assign */
import React, { useEffect } from "react";
import api from "../../services/api";

const Direct: React.FC = () => {
    // const message = `Olá, falei com você no Instagram e gostaria de saber mais sobre as ofertas de iPhone.`;

    useEffect(() => {
        api.get("/vendedores/loja/proximo/1/direct").then(
            (response: {
                data: { vendedor: { celular: any }; mensagem: any };
            }) =>
                (window.location.href = `https://api.whatsapp.com/send?phone=${response.data.vendedor.celular}&text=${response.data.mensagem}`),
        );
    }, []);

    return <p />;
};

export default Direct;
